function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "40",
  height: "40",
  version: "1.1",
  id: "Capa_1",
  xmlns: "http://www.w3.org/2000/svg",
  x: "0",
  y: "0",
  viewBox: "0 0 60.254 60.254",
  xmlSpace: "preserve"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M29.008 48.308C12.532 48.308.672 31.279.175 30.554a1 1 0 01.039-1.184c.561-.712 13.906-17.424 29.913-17.424 17.953 0 29.474 16.769 29.956 17.482a1 1 0 01-.007 1.129c-.475.688-11.842 16.818-29.899 17.721a24.1 24.1 0 01-1.169.03zM2.267 30.028c2.326 3.098 13.553 16.967 27.812 16.254 15.237-.76 25.762-13.453 27.938-16.3-2.175-2.912-12.811-16.035-27.889-16.035-13.428 0-25.357 13.137-27.861 16.081z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.127 37.114c-3.852 0-6.986-3.135-6.986-6.986s3.134-6.985 6.986-6.985 6.986 3.135 6.986 6.985c0 3.851-3.134 6.986-6.986 6.986z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.127 42.614c-6.885 0-12.486-5.602-12.486-12.486 0-6.883 5.602-12.485 12.486-12.485s12.486 5.602 12.486 12.485c0 6.884-5.6 12.486-12.486 12.486zm0-22.973c-5.782 0-10.486 4.704-10.486 10.486 0 5.781 4.704 10.485 10.486 10.485s10.486-4.704 10.486-10.485c0-5.782-4.703-10.486-10.486-10.486z"
})));